import { VStack } from "@zenchef/styled-system/jsx";
import BaseFilter, { BaseFilterProps } from "./BaseFilter";
import FilterGroup from "./FilterGroup";
import FilterTags, { FilterTagsProps } from "./FilterTags";
import FilterItem from "./FilterItem";

export interface FilterProps extends BaseFilterProps, FilterTagsProps {
  hiddenTags?: boolean;
}

const Filter = ({
  values,
  tags,
  clearAllValuesLabel,
  hiddenTags,
  onClearAllValues,
  onClearValue,
  ...props
}: FilterProps) => {
  const filterTagsProps: FilterTagsProps = {
    values,
    tags,
    items: props.items,
    sections: props.sections,
    clearAllValuesLabel,
    onClearAllValues,
    onClearValue,
  };
  return (
    <VStack alignItems="initial" gap="gap.2">
      <BaseFilter {...props} />
      {!hiddenTags ? <FilterTags {...filterTagsProps} /> : null}
    </VStack>
  );
};

Filter.Item = FilterItem;
Filter.Group = FilterGroup;
Filter.Tags = FilterTags;

export default Filter;
